import PannellumControlsBasic from '../pannellum-controls/pannellum-controls-basic';
import PannellumControls from '../pannellum-controls/pannellum-controls-player';

require('./style/pannellum-controls-admin.less');

export default class PannellumAdminControls extends PannellumControls {
    addBasicControls() {
        super.addBasicControls();
        // this._addSimpleControl('e3plan', 'e3plan', PannellumControlsBasic.POSITION.CENTER, 105);
    }
}
